import dayjs from "dayjs";

export const formatPrice = (price) => {
  if (price === null || price === undefined) return "-";
  return new Intl.NumberFormat("ko-KR", {
    style: "currency",
    currency: "KRW",
    maximumFractionDigits: 0,
  }).format(price);
};

export const formatDate = (dateString) => {
  if (!dateString) return "-";
  return dayjs(dateString).format("YYYY-MM-DD");
};

export const formatDateTime = (dateString) => {
  if (!dateString) return "-";
  return dayjs(dateString).format("YYYY-MM-DD HH:mm");
};

export const extractBillingPeriod = (notes) => {
  if (!notes) return null;
  const match = notes.match(
    /청구기간:\s*(\d{4}-\d{2}-\d{2})\s*~\s*(\d{4}-\d{2}-\d{2})/
  );
  if (match) {
    return `${match[1]} ~ ${match[2]}`;
  }
  return null;
};

export const formatBusinessNumber = (num) => {
  if (!num || num.length !== 10) return num || "-";
  return `${num.slice(0, 3)}-${num.slice(3, 5)}-${num.slice(5)}`;
};

export const formatPhoneNumber = (phone) => {
  if (!phone) return "-";
  const numbers = phone.replace(/\D/g, "");
  if (numbers.length === 11) {
    return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(7)}`;
  }
  if (numbers.length === 10) {
    return `${numbers.slice(0, 3)}-${numbers.slice(3, 6)}-${numbers.slice(6)}`;
  }
  return phone;
};
